import moment from 'moment';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import VueSelect from 'vue-select'; // needed for multiselect not ported yet
import 'vue-select/dist/vue-select.css'; // import css
import DatePicker from 'vuejs-datepicker';
import { Cell } from '../backend/backendapi';
import { CategoryChart, PieChart } from '../revoreporting/AmChartWrapper';
import { ARequestVM } from "../revoreporting/Api";

@Component(
    {
        name: 'report',
        components: {
            DatePicker,
            VueSelect,
        }
    })
export default class ReportComponent extends Vue {
    //refs needed to access elements from template
    $refs!: {
        chartdiv: HTMLDivElement,
        piediv: HTMLDivElement
    }
    //startOfMonth: string = moment().clone().startOf('month').format('YYYY-MM-DD hh:mm');
    //endOfMonth: string = moment().clone().endOf('month').format('YYYY-MM-DD hh:mm');
    startOfDay: string = moment().clone().startOf('day').format();
    endOfDay: string = moment().clone().startOf('day').add('day', 1).format();
    start: string = this.startOfDay;
    end: string = this.endOfDay;
    chart: CategoryChart | undefined;
    chart2: PieChart | undefined;
    cells: Cell[] = [];
    selectedCell: Cell | undefined;
    selectKey: number = 0;

    //configure chart here
    mounted() {
        this.fetchcells();

        let request = new ARequestVM();
        request.Route = "pareto";
        request.startDate = this.start;
        request.endDate = this.end;

        this.chart = new CategoryChart(this.$refs.chartdiv);
        this.chart.requestVM = request;

        this.chart.setFetchApi('reportingapi');
        //this.chart.filterCategory("search=x"); // not used
        this.chart.fetchData();

        let request2 = new ARequestVM();
        request2.Route = "pieChart";
        request2.startDate = this.start;
        request2.endDate = this.end;
        this.chart2 = new PieChart(this.$refs.piediv);
        this.chart2.requestVM = request2;
        this.chart2.setFetchApi('reportingapi');
        this.chart2.fetchData();
    }
    onClick(selectedDate: Date) {
        console.log("datetime clicked date=" + selectedDate);
        this.start = moment(selectedDate).format();
        var nextDay = new Date(selectedDate);
        nextDay.setDate(nextDay.getDate() + 1);
        this.end = moment(nextDay).format();

        let request = new ARequestVM();
        request.Route = "pareto";
        request.startDate = this.start;
        request.endDate = this.end;
        if (this.selectedCell !== undefined && this.selectedCell !== null)
            request.addSingleEntityFilter("id=" + this.selectedCell.id);

        let request2 = new ARequestVM();
        request2.Route = "pieChart";
        request2.startDate = this.start;
        request2.endDate = this.end;
        if (this.selectedCell !== undefined && this.selectedCell !== null)
            request2.addSingleEntityFilter("id=" + this.selectedCell.id);
        if (this.chart !== undefined && this.chart2 !== undefined) {
            this.chart.requestVM = request;
            this.chart.fetchData();
            this.chart2.requestVM = request2;
            this.chart2.fetchData();
            this.selectKey += 1;
        }
    }

    onClickEnd(selectedDate: Date) {
        console.log("datetime end clicked date=" + selectedDate);
        let request = new ARequestVM();
        request.Route = "pareto";
        request.startDate = this.start;
        request.endDate = moment(selectedDate).format();;
        if (this.selectedCell !== undefined && this.selectedCell !== null)
            request.addSingleEntityFilter("id=" + this.selectedCell.id);

        let request2 = new ARequestVM();
        request2.Route = "pieChart";
        request2.startDate = this.start;
        request2.endDate = moment(selectedDate).format();;
        if (this.selectedCell !== undefined && this.selectedCell !== null)
            request2.addSingleEntityFilter("id=" + this.selectedCell.id);
        if (this.chart !== undefined && this.chart2 !== undefined) {
            this.chart.requestVM = request;
            this.chart.fetchData();
            this.chart2.requestVM = request2;
            this.chart2.fetchData();
            this.selectKey += 1;
        }
    }

    fetchcellsServ(): Promise<Cell[]> {
        return fetch('api/cell/cells')
            .then(response => response.json() as Promise<Cell[]>);
    }
    fetchcells() {
        this.fetchcellsServ()
            .then(data => {
                this.cells = data as Cell[];
            });
    }
    setSelected() { // force update that way
        this.selectKey += 1;
    }

}
